import { render } from "./FooterAksi.vue?vue&type=template&id=5ffe132e"
import script from "./FooterAksi.vue?vue&type=script&lang=js"
export * from "./FooterAksi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__